import LTR from "@brand-icons/global/pin-horeca/pin-horeca-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinHorecaIcon = iconFactory("PinHorecaIcon", LTR);
